import React from 'react';
import { useAuth } from '../../Common/Configurations/AuthContext';
import { useSearchTab } from '../SearchTabContext';

const TemplateHeaderHybrid = () => {
  const { user } = useAuth();
  const { activeTab, setActiveTab } = useSearchTab();
  const logoUrl = user?.logo || 'https://via.placeholder.com/150x40?text=Your+Logo';
  
  const navLinks = [
    { id: 'home', name: 'Home' },
    { id: 'flights', name: 'Flights' },
    { id: 'hotels', name: 'Hotels' },
    { id: 'packages', name: 'Packages' },
    { id: 'about', name: 'About Us' },
    { id: 'contact', name: 'Contact' },
  ];

  // Define styles using CSS variables with fallbacks
  const styles = {
    header: {
       backgroundColor: 'var(--header-bg-color, #333)',
      height: '80px', // Set a fixed, smaller height for the header bar
      position: 'relative', // This is crucial to act as an anchor for the logo
    },
     logoLink: {
      position: 'absolute',
      // 'top: 50%' and 'transform' vertically center the logo link
      top: '50%', 
      transform: 'translateY(-50%)',
      left: '2rem', // Position from the left
      zIndex: 10, // Ensure the logo is on top of other content
    },
    logoImage: {
      height: '80px', // Make the logo taller than the header
      width: 'auto',
      backgroundColor: 'var(--header-bg-color, white)', // Give it a background to cover what's behind
      padding: '1px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)', // Give it a "pop" effect
    },
    navLink: {
      color: 'var(--header-text-color, white)',
    }
  };

  return (
     <header className="navbar navbar-expand-lg px-4 d-flex align-items-center" style={styles.header}>
      <a className="navbar-brand" href="#" style={styles.logoLink}>
        <img src={logoUrl} alt="Company Logo" style={styles.logoImage} />
      </a>
      
     <div className="collapse navbar-collapse">
        {/* The navigation is now pushed over to account for the larger logo's space */}
        <ul className="navbar-nav mx-auto gap-3" style={{ paddingLeft: '200px' }}>
          {navLinks.map(link => (
            <li className="nav-item" key={link.id}>
              <a 
                className={`nav-link fs-5 ${activeTab === link.id ? 'active fw-bold' : ''}`} 
                href="#" 
                style={styles.navLink}
                onClick={(e) => { e.preventDefault(); setActiveTab(link.id); }}
              >
                {link.name}
              </a>
            </li>
          ))}
        </ul>
        <a className="btn btn-light rounded-pill px-4" href="#">Enquiry Now</a>
      </div>
    </header>
  );
};

export default TemplateHeaderHybrid;